import PatchContactIdMappingRequestModelBase from '../_generated/modelBases/patch-contact-id-mapping-request-model-base';

export default class PatchContactIdMappingRequestModel extends PatchContactIdMappingRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
